import { ca } from '@cian/analytics';

export function trackStripSwipe(label: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AnalisysOnline',
    action: 'HeaderSwipe',
    label,
  });
}
